import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { AnimatedAxis as AnAxis } from '@visx/react-spring';
import { useTheme } from '@material-ui/core/styles';

const YearAxis = ({ scale, bins, dimensions }) => {
  const { maxHeight, margin } = dimensions;
  const theme = useTheme();
  const axisColor = theme.palette.colorant.main;

  // useMemo in YearAxis calculates the position of
  // the year values relative the sorted ascending bins
  // First, the bins timeline is split into equal parts
  // Then, unique years are given a position according
  // to how many months of data exist between previous
  // year and current year.
  const years = useMemo(
    () =>
      bins.reduce(
        ([dates, positions], entry, i) => {
          // partSize and axis scale are
          // calculated on the same domain
          const partSize = 1 / bins.length;
          const nextEntry = bins[i + 1];
          const previous = entry.date.getFullYear();
          const next = nextEntry?.date?.getFullYear();

          if (previous < next) {
            positions.push((i + 1) * partSize * bins.length);
            dates.push(new Date(`1/1/${nextEntry.date.getFullYear()}`));
          }
          return [dates, positions];
        },
        [[], []]
      ),
    [bins]
  );

  const [dates, positions] = years;

  return (
    <AnAxis
      orientation="bottom"
      top={maxHeight + margin.top}
      rangePadding={0.5}
      scale={scale}
      stroke={axisColor}
      tickFormat={(_, i) => {
        return dates[i].getFullYear();
      }}
      tickValues={positions}
      tickLength={22}
      tickTransform="translate(0,7)"
      tickStroke={axisColor}
      tickLabelProps={() => ({
        fontSize: 11,
        fontWeight: 'bold',
        textAnchor: 'middle',
        dy: '4',
        fill: axisColor,
      })}
    />
  );
};

YearAxis.propTypes = {
  scale: PropTypes.func.isRequired,
  bins: PropTypes.array.isRequired,
  dimensions: PropTypes.object.isRequired,
};

export default YearAxis;
